import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  const bonuses = ['𝗥𝗲𝗽𝗿𝗼𝗴𝗿𝗮𝗺𝗮𝗰𝗶𝗼́𝗻 𝗺𝗲𝗻𝘁𝗮𝗹\n¡Deja de autosabotearte!', '𝗥𝗲𝘀𝗲𝘁 𝗺𝗲𝘁𝗮𝗯𝗼́𝗹𝗶𝗰𝗼 𝗱𝗲 𝟳 𝗱𝗶́𝗮𝘀.\n¡Desintoxica tu cuerpo!', '𝗠𝗲𝗻𝘂́ 𝗶𝗻𝘁𝗲𝗹𝗶𝗴𝗲𝗻𝘁𝗲.\n¡Deja de preocuparte por que vas a comer hoy!'];
  return <section className="pt-4 pb-24 px-4 bg-brand-bg overflow-hidden" data-id="element-11">
      <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-4" data-id="element-13">
          <h2 className="text-4xl md:text-5xl font-poppins font-black text-brand-text mb-3" data-id="element-14">
            🎁 3 BONOS PARA ORGANIZARTE
          </h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-15"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full max-w-2xl mb-6 relative" data-id="element-16">
          <div className="absolute inset-0 bg-brand-accent/10 blur-[80px] rounded-full" data-id="element-17"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5YAtwhwrsvBxYnAbHMv7ip/bonus.png" alt="Bonus Exclusivos" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-18" />
        </motion.div>

        <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 mb-20" data-id="element-19">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col gap-3 bg-white p-5 rounded-2xl border border-green-200 shadow-sm" data-id="element-20">
              <div className="flex items-center justify-between" data-id="element-21">
                <span className="inline-flex items-center gap-2 bg-green-50 text-green-700 font-poppins font-bold text-sm px-3 py-1 rounded-full border border-green-200" data-id="element-22">
                  🎁 Bono {i + 1}
                </span>
                <span className="inline-flex items-center gap-2" data-id="element-23">
                  <span className="text-red-400 line-through text-sm font-medium" data-id="element-24">
                    $7.000
                  </span>
                  <span className="inline-block bg-brand-accent text-white font-poppins font-bold text-xs uppercase tracking-wider px-3 py-1 rounded-full shadow-sm" data-id="element-25">
                    GRATIS
                  </span>
                </span>
              </div>
              <p className="text-base md:text-lg font-poppins font-medium text-brand-textBody whitespace-pre-line" data-id="element-26">
                {bonus}
              </p>
            </motion.div>)}
        </div>

        {/* Transformation Box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="w-full bg-white border-2 border-green-400 rounded-3xl p-8 md:p-12 shadow-lg relative text-center" data-id="element-27">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-green-600 text-white font-black font-poppins px-8 py-2 rounded-full text-lg shadow-md" data-id="element-28">
            RESULTADO
          </div>

          <div className="mt-6 space-y-8 max-w-2xl mx-auto" data-id="element-29">
            <div className="bg-green-50 border border-green-100 p-6 rounded-2xl" data-id="element-30">
              <p className="text-gray-500 font-bold mb-2 uppercase text-xs tracking-wider" data-id="element-31">
                Pasás de:
              </p>
              <p className="text-lg md:text-xl font-medium text-gray-700" data-id="element-32">
                👉 "No sé qué comer, todo me engorda"😔
              </p>
            </div>

            <div className="flex justify-center" data-id="element-33">
              <div className="w-1 h-8 bg-gradient-to-b from-green-200 to-brand-accent" data-id="element-34"></div>
            </div>

            <div className="bg-green-100 border border-brand-accent p-6 rounded-2xl" data-id="element-35">
              <p className="text-brand-accent font-bold mb-2 uppercase text-xs tracking-wider" data-id="element-36">
                A:
              </p>
              <p className="text-lg md:text-xl font-bold text-brand-text" data-id="element-37">
                👉 "Sé exactamente qué comer y estoy logrando mi objetivo"😁
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-green-100" data-id="element-38">
            <h4 className="text-xl font-poppins font-bold text-brand-accent mb-2" data-id="element-39">
              ⚡ ACCESO INMEDIATO
            </h4>
            <p className="text-gray-500" data-id="element-40">Comprás → lo recibís → empezás hoy</p>
          </div>
        </motion.div>
      </div>
    </section>;
}